export class ErrorUtils {
  public static extractErrorMessage(error: unknown): string {
    if (!error) return 'Unknown error';

    if (typeof error === 'string') {
      return error;
    }

    if (error instanceof ProgressEvent) {
      return 'Network error or request aborted';
    }

    if (typeof error === 'object') {
      // If it's a dictionary of field-level errors:
      const fieldMessages = this.flattenFieldErrors(error);
      if (fieldMessages.length) {
        return [...new Set(fieldMessages)].join(' ');
      }
    }

    return 'An unexpected error occurred.';
  }

  private static flattenFieldErrors(obj: unknown): string[] {
    const messages: string[] = [];

    if (obj && typeof obj === 'object') {
      for (const key in obj) {
        const val = (obj as Record<string, unknown>)[key];
        if (Array.isArray(val)) {
          for (const item of val) {
            if (typeof item === 'string') {
              messages.push(item);
            }
          }
        }
      }
    }

    return messages;
  }
}
